import '@/scss/pages/worksheets.scss'

import { useSidebarBottom } from '@/js/common/sidebar-bottom'
import { checkQuery } from '@/js/helpers/check-query'
import header from '../layout/header'
import { cookiesPopUp } from '../common/cookies'
import fullForm from '../section/home/full-form'
import initStrip from '../section/blog/strip'
import {
  setTrackExitPopupCloseEvent,
  setTrackStripCloseEvent
} from '../common/button-track'
import moveToLand from '../section/home/move-to-land'

document.addEventListener('DOMContentLoaded', function () {
  header()
  checkQuery()
  cookiesPopUp()
  fullForm()
  initStrip()
  setTrackStripCloseEvent()
  setTrackExitPopupCloseEvent()
  moveToLand()
  useSidebarBottom()
})
